import {
  editSwitchDarkMode,
  editSwitchImageType,
  editSwitchMediaType,
  editSwitchPosition
} from 'src/store/modules/switchButton';

import {
  editBg,
  editBgColor,
  editBgImage,
  editBgImageBlur,
  editRadius,
  editCurrentIndex,
  editDeeplink,
  editBgVideo
  // editStarIndex,
  // editCurrentBranchIndex
} from 'src/store/modules/imageUpload';
import {
  editColor,
  // editContents,
  editFontFamily,
  editFontSize,
  editFontWeight,
  editPreFontSize,
  // editSubTitle,
  editText,
  editTextAlign
  // editTitle
} from 'src/store/modules/editText';
import {
  editBtnAgain,
  editBtnBgColor,
  editBtnColor,
  editBtnFontFamily,
  editBtnFontSize,
  editBtnFontWeight,
  editBtnPreFontSize,
  // editBtnRadius,
  editBtnText,
  editBtnTextAlign,
  editBtnType
} from 'src/store/modules/buttons';
import {
  editTracking,
  editButton1,
  editButton2,
  editLogCustom
} from 'src/store/modules/trackings';
import { editUserCompany } from 'src/store/modules/client';

const setInitValue = (dispatch: any, initValue: any) => {
  dispatch(editCurrentIndex(0));

  if (initValue?.btnType) dispatch(editBtnType(initValue?.btnType));
  if (initValue?.company) dispatch(editUserCompany(initValue?.company));
  if (initValue?.bg) dispatch(editBg(initValue?.bg));
  if (initValue?.bgColor) dispatch(editBgColor(initValue?.bgColor));
  if (initValue?.bgImage) dispatch(editBgImage(initValue?.bgImage));
  // 비디오 링크 추가 24.12.03
  if (initValue?.bgVideo) dispatch(editBgVideo(initValue?.bgVideo));
  if (initValue?.bgOpacity) dispatch(editBgImageBlur(initValue?.bgOpacity));
  if (initValue?.deeplink) dispatch(editDeeplink(initValue?.deeplink));
  if (initValue?.radius) dispatch(editRadius(initValue?.radius));
  if (initValue?.text) dispatch(editText(initValue?.text));
  if (initValue?.fontSize) dispatch(editPreFontSize(initValue?.fontSize));
  if (initValue?.fontSize) dispatch(editFontSize(initValue?.fontSize));
  if (initValue?.fontWeight) dispatch(editFontWeight(initValue?.fontWeight));
  if (initValue?.color) dispatch(editColor(initValue?.color));
  if (initValue?.fontFamily) dispatch(editFontFamily(initValue?.fontFamily));
  if (initValue?.textAlign) dispatch(editTextAlign(initValue?.textAlign));

  if (initValue?.btnText) dispatch(editBtnText(initValue?.btnText));
  if (initValue?.btnFontSize)
    dispatch(editBtnPreFontSize(initValue?.btnFontSize));
  if (initValue?.btnFontSize) dispatch(editBtnFontSize(initValue?.btnFontSize));
  if (initValue?.btnFontWeight)
    dispatch(editBtnFontWeight(initValue?.btnFontWeight));
  if (initValue?.btnColor) dispatch(editBtnColor(initValue?.btnColor));
  if (initValue?.btnBgColorR)
    dispatch(
      editBtnBgColor(
        initValue?.btnBgColorR,
        initValue?.btnBgColorG,
        initValue?.btnBgColorB,
        initValue?.btnBgColorA
      )
    );
  if (initValue?.btnFontFamily)
    dispatch(editBtnFontFamily(initValue?.btnFontFamily));
  if (initValue?.btnTextAlign)
    dispatch(editBtnTextAlign(initValue?.btnTextAlign));
  if (initValue?.btnAgain) dispatch(editBtnAgain(initValue?.btnAgain));

  if (initValue?.tracking) dispatch(editTracking(initValue?.tracking));
  if (initValue?.button1) dispatch(editButton1(initValue?.button1));
  if (initValue?.button2) dispatch(editButton2(initValue?.button2));
  if (initValue?.logCustom) dispatch(editLogCustom(initValue?.logCustom));
  if (initValue?.switchPosition)
    dispatch(editSwitchPosition(initValue?.switchPosition));
  if (initValue?.switchDarkMode)
    dispatch(editSwitchDarkMode(initValue?.switchDarkMode));
  if (initValue?.switchImageType)
    dispatch(editSwitchImageType(initValue?.switchImageType));
  // 비디오<->이미지 스위치 추가 24.12.03
  if (initValue?.switchMediaType)
    dispatch(editSwitchMediaType(initValue?.switchMediaType));
};

export default setInitValue;
